<template>
	<div>
		<navbar :hasSearch="true" />
		<div id="content">
			<template v-if="loading">
				<div class="d-flex justify-content-center align-items-center" style="height: 60vh;">
					<div class="spinner-border text-primary" role="status">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="row">
					<div class="col-md-6 pb-3">
						<div class="card h-100">
							<ol class="breadcrumb lighten-4 my-auto">
								<li class="breadcrumb-item">
									<router-link :to="{ name: 'landingPage' }">
										<a class="black-text" href="#">Home</a>
									</router-link>
									<i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
								</li>
								<li class="breadcrumb-item active font-weight-bold">
									On Hold Rules
									<i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
								</li>
							</ol>
						</div>
					</div>
					<quick-links></quick-links>
				</div>

				<div class="card border border-light rounded p-3">
					<div class="mt-2 ml-auto">
						To change the status of a rule, click Enabled/Disabled
					</div>
					<div class="row">
						<div class="col-12">
							<h3>Customer Bill</h3>
						</div>
					</div>
					<div v-for="(rule, index) in customerBillRules" :key="rule.RuleName" class="row align-items-center my-2"
						:style="{ backgroundColor: index % 2 === 0 ? 'white' : '#f2f2f2' }">
						<div class="col">
							<span>{{ rule.Label }}</span>
						</div>
						<div v-if="rule.HasInput" class="col-1 d-flex align-items-start">
							<div class="input-group" style="flex-wrap: nowrap">
								<input type="number" v-model="rule.Value" class="form-control" style="min-width: 40px"
									@keypress="restrictInput" />
								<div class="input-group-append">
									<span class="input-group-text"><b>Days</b></span>
								</div>
							</div>
						</div>
						<div class="col-auto ml-auto">
							<button class="btn" style="width: 6em"
								:class="rule.Enabled ? 'btn btn-success' : 'btn btn-danger'"
								:disabled="rule.RuleName === 'PreviousStatementOnHoldRule'"
								@click.prevent="toggleEnabled(rule)">
								{{ rule.Enabled ? 'Enabled' : 'Disabled' }}
							</button>
						</div>
					</div>
					<div v-for="(rule, index) in customerBillRulesWithInput" :key="rule.RuleName"
						class="row align-items-center mt-2"
						:style="{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }">
						<div class="col-4">{{ rule.Label }}</div>
						<div v-if="rule.HasInput" class="col-1 d-flex align-items-start my-2">
							<div class="input-group" style="flex-wrap: nowrap">
								<input type="number" v-model="rule.Value" class="form-control" style="min-width: 70px"
									@keypress="restrictInput" />
								<div class="input-group-append">
									<span class="input-group-text"><b>Days</b></span>
								</div>
							</div>
						</div>
						<div class="col-auto ml-auto">
							<button class="btn" style="width: 6em"
								:class="rule.Enabled ? 'btn btn-success' : 'btn btn-danger'"
								@click.prevent="toggleEnabled(rule)">
								{{ rule.Enabled ? 'Enabled' : 'Disabled' }}
							</button>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<h3 class="mt-5">Elec - Consumption</h3>
						</div>
					</div>
					<div v-for="(rule, index) in elecConsumptionRules" :key="rule.RuleName" class="row align-items-center my-2"
						:style="{ backgroundColor: index % 2 === 0 ? 'white' : '#f2f2f2' }">
						<div class="col-4">{{ rule.Label }}</div>

						<!-- Input -->
						<div class="col-1 d-flex align-items-start">
							<div class="input-group" style="flex-wrap: nowrap">
								<input type="number" @keypress="restrictInput" v-model="rule.Amount"
									class="form-control mb-0" style="min-width: 70px" />
								<div class="input-group-append">
									<span v-if="rule.Symbol" class="input-group-text"
										style="min-width: 40px; text-align: center"><b>{{ rule.Symbol }}</b></span>
								</div>
							</div>
						</div>

						<!-- Checkboxes -->
						<div v-if="rule.Checkboxes" class="ml-auto col-2">
							<div class="row align-items-center">
								<div class="col-xl-6 d-flex align-items-center">
									<input type="radio" class="mt-0" :checked="rule.MeterPoint"
										@click="setRadio(rule, 'MeterPoint')" id="meterPoint" />
									<label class="ml-1 mb-0">Meter Point</label>
								</div>

								<div class="col-xl-6 d-flex align-items-center">
									<input type="radio" class="mt-0" :checked="rule.Statement"
										@click="setRadio(rule, 'Statement')" id="statement" />
									<label class="ml-1 mb-0">Statement</label>
								</div>
							</div>
						</div>
						<!--  -->

						<div class="col-3 d-flex justify-content-end">
							<div>
								<button class="btn" style="width: 6em" @click.prevent="toggleEnabled(rule)"
									:class="rule.Enabled ? 'btn btn-success' : 'btn btn-danger'">
									{{ rule.Enabled ? 'Enabled' : 'Disabled' }}
								</button>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<h3 class="mt-5">Gas - Consumption</h3>
						</div>
					</div>
					<div v-for="(rule, index) in gasConsumptionRules" :key="rule.RuleName" class="row align-items-center my-2"
						:style="{ backgroundColor: index % 2 === 0 ? 'white' : '#f2f2f2' }">
						<div class="col-4">{{ rule.Label }}</div>

						<!-- Input -->
						<div class="col-1 d-flex align-items-start">
							<div class="input-group" style="flex-wrap: nowrap">
								<input type="number" @keypress="restrictInput" v-model="rule.Amount"
									class="form-control mb-0" style="min-width: 70px" />
								<div class="input-group-append">
									<span v-if="rule.Symbol" class="input-group-text"
										style="min-width: 40px; text-align: center"><b>{{ rule.Symbol }}</b></span>
								</div>
							</div>
						</div>

						<!-- Checkboxes -->
						<div v-if="rule.Checkboxes" class="ml-auto col-2">
							<div class="row align-items-center">
								<div class="col-xl-6 d-flex align-items-center">
									<input type="radio" class="mt-0" :checked="rule.MeterPoint"
										@click="setRadio(rule, 'MeterPoint')" id="meterPoint" />
									<label class="ml-1 mb-0">Meter Point</label>
								</div>

								<div class="col-xl-6 d-flex align-items-center">
									<input type="radio" class="mt-0" :checked="rule.Statement"
										@click="setRadio(rule, 'Statement')" id="statement" />
									<label class="ml-1 mb-0">Statement</label>
								</div>
							</div>
						</div>

						<div class="col-3 d-flex justify-content-end">
							<button class="btn" style="width: 6em" @click.prevent="toggleEnabled(rule)"
								:class="rule.Enabled ? 'btn btn-success' : 'btn btn-danger'">
								{{ rule.Enabled ? 'Enabled' : 'Disabled' }}
							</button>
						</div>
					</div>

					<!-- begin - Tolerance Rules -->
					<div v-if="toleranceRuleEnabled">
						<div v-for="(rule, index) in toleranceRules" :key="rule.RuleName">
							<div class="row">
								<div class="col-12">
									<h3 class="mt-5">
										{{ rule.Elec ? 'Elec' : 'Gas' }} - Tolerance Rule
									</h3>
								</div>
							</div>

							<div class="row align-items-center my-2"
								:style="{ backgroundColor: index % 2 === 0 ? 'white' : '#f2f2f2' }">
								<div class="col-4">
									{{ rule.Label }}
								</div>

								<!-- Month Rule Inputs -->
								<div class="col-3 d-flex align-items-center">
									<div class="input-group mr-3" style="flex-wrap: nowrap">
										<input
											type="number"
											min="1"
											:placeholder="1"
											@keypress="restrictInput"
											v-model="rule.MonthRule.MinAmount"
											@change="enforceMonthMin(rule.MonthRule, 'MinAmount')"
											class="form-control"
										/>
										<div class="input-group-append">
											<span v-if="rule.MonthRule.MinSymbol" class="input-group-text">
												<b>{{ rule.MonthRule.MinSymbol }}</b>
											</span>
										</div>
									</div>

									<div class="input-group" style="flex-wrap: nowrap">
										<input
											type="number"
											min="1"
											:placeholder="1"
											@keypress="restrictInput"
											v-model="rule.MonthRule.MaxAmount"
											@change="enforceMonthMin(rule.MonthRule, 'MaxAmount')"
											class="form-control"
										/>
										<div class="input-group-append">
											<span v-if="rule.MonthRule.MaxSymbol" class="input-group-text">
												<b>{{ rule.MonthRule.MaxSymbol }}</b>
											</span>
										</div>
									</div>
								</div>

								<!-- Percentage Rule Inputs -->
								<div class="col-3 d-flex align-items-center">
									<div class="input-group mr-3" style="flex-wrap: nowrap">
										<input type="number" title="The min value" @keypress="restrictInput"
											v-model="rule.PercentageRule.MinAmount" class="form-control" />
										<div class="input-group-append">
											<span v-if="rule.PercentageRule.MinSymbol" class="input-group-text">
												<b>{{ rule.PercentageRule.MinSymbol }}</b>
											</span>
										</div>
									</div>

									<div class="input-group" style="flex-wrap: nowrap">
										<input type="number" title="The max value" @keypress="restrictInput"
											v-model="rule.PercentageRule.MaxAmount" class="form-control" />
										<div class="input-group-append">
											<span v-if="rule.PercentageRule.MaxSymbol" class="input-group-text">
												<b>{{ rule.PercentageRule.MaxSymbol }}</b>
											</span>
										</div>
									</div>
								</div>

								<!-- Enable Toggle -->
								<div class="col-2 d-flex justify-content-end">
									<button class="btn" style="width: 6em" @click.prevent="toggleEnabled(rule)"
										:class="rule.Enabled ? 'btn btn-success' : 'btn btn-danger'">
										{{ rule.Enabled ? 'Enabled' : 'Disabled' }}
									</button>
								</div>
							</div>
						</div>
					</div> <!-- end - Tolerance Rules -->

					<!-- Begin - Bill Run Rules -->
					<div class="row">
						<div class="col-12">
							<h3 class="mt-5">Bill Run</h3>
						</div>
					</div>

					<div v-for="(rule, index) in billRunRules" :key="rule.RuleName" class="row align-items-center my-2"
						:style="{ backgroundColor: index % 2 === 0 ? 'white' : '#f2f2f2' }">
						<div class="col-4">{{ rule.Label }}</div>

						<!-- Inputs -->
						<div class="col-2 d-flex align-items-center">
							<div class="input-group mr-3" style="flex-wrap: nowrap">
								<input type="number" @keypress="restrictInput" v-model="rule.Gas" class="form-control"
									style="min-width: 70px" />
								<div class="input-group-append">
									<span class="input-group-text"
										style="min-width: 40px; text-align: center"><b>Gas</b></span>
								</div>
							</div>
							<div class="input-group" style="flex-wrap: nowrap">
								<input type="number" @keypress="restrictInput" v-model="rule.Elec" class="form-control"
									style="min-width: 70px" />
								<div class="input-group-append">
									<span class="input-group-text"
										style="min-width: 40px; text-align: center"><b>Elec</b></span>
								</div>
							</div>
						</div>

						<!-- Checkboxes -->
						<div class="ml-auto col-2">
							<div class="row align-items-center">
								<div class="col-xl-6 d-flex align-items-center">
									<input type="radio" class="mt-0" :checked="rule.MeterPoint"
										@click="setRadio(rule, 'MeterPoint')" id="meterPoint" />
									<label class="ml-1 mb-0">Meter Point</label>
								</div>

								<div class="col-xl-6 d-flex align-items-center">
									<input type="radio" class="mt-0" :checked="rule.Statement"
										@click="setRadio(rule, 'Statement')" id="statement" />
									<label class="ml-1 mb-0">Statement</label>
								</div>
							</div>
						</div>
						<!--  -->

						<div class="col-xl-3 col-2 align-items-center">
							<div class="row justify-content-end">
								<div class="form-group col-xl-auto d-flex justify-content-end" style="position: relative">
									<label :class="{ 'd-xl-none': index }" class="service-label"><b>Gas</b></label>
									<button class="btn mt-4" style="width: 6em" @click.prevent="toggleEnabled(rule, 'gas')"
										:class="rule.GasEnabled ? 'btn btn-success' : 'btn btn-danger'
											">
										{{ rule.GasEnabled ? 'Enabled' : 'Disabled' }}
									</button>
								</div>
								<div class="form-group col-xl-auto d-flex justify-content-end" style="position: relative">
									<label :class="{ 'd-xl-none': index }" class="service-label"><b>Elec</b></label>
									<button class="btn mt-4" style="width: 6em" @click.prevent="toggleEnabled(rule, 'elec')"
										:class="rule.ElecEnabled ? 'btn btn-success' : 'btn btn-danger'
											">
										{{ rule.ElecEnabled ? 'Enabled' : 'Disabled' }}
									</button>
								</div>
							</div>
						</div>
					</div>
					<!-- End - Bill Run Rules -->

					<div class="row mt-5">
						<div class="col-auto">
							<button @click="submit" type="submit" class="btn btn-success mr-2 mb-3">
								Submit
							</button>
							<button type="button" class="btn btn-danger mb-3" @click="cancelForm">
								Cancel
							</button>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<style>
.service-label {
	position: absolute;
	left: 50%;
	transform: translate(-50%, -10%);
}
</style>

<script>
import Navbar from '@/components/Navbar.vue';
import QuickLinks from '@/components/QuickLinks.vue';

export default {
	components: {
		Navbar,
		QuickLinks,
	},

	data() {
		return {
			localToleranceRules: [],
			loading: true,
		};
	},

	computed: {
		dto() {
			return {
				CustomerBillRules: [
					...this.customerBillRules,
					...this.customerBillRulesWithInput,
				],
				BillRunRules: this.billRunRules,
				ElecConsumptionRules: this.elecConsumptionRules,
				GasConsumptionRules: this.gasConsumptionRules,
				ElecToleranceRules: this.localToleranceRules.filter(
					(rule) => rule.Elec === true
				),
				GasToleranceRules: this.localToleranceRules.filter(
					(rule) => rule.Gas === true
				),
			};
		},
		customerBillRules() {
			const rules = this.$store.state.onHoldRules.CustomerBillRules;
			return rules ? rules.filter((rule) => !rule.HasInput) : [];
		},
		customerBillRulesWithInput() {
			const rules = this.$store.state.onHoldRules.CustomerBillRules;
			return rules ? rules.filter((rule) => rule.HasInput) : [];
		},
		billRunRules() {
			return this.$store.state.onHoldRules.BillRunRules || [];
		},
		elecConsumptionRules() {
			return this.$store.state.onHoldRules.ElecConsumptionRules || [];
		},
		gasConsumptionRules() {
			return this.$store.state.onHoldRules.GasConsumptionRules || [];
		},
		toleranceRules() {
			return this.localToleranceRules;
		},
		toleranceRuleEnabled() {
			return this.localToleranceRules.length > 0;
		},
	},

	async mounted() {
		try {
			await this.$store.dispatch('getOnHoldRules'); // always refresh

			this.localToleranceRules = JSON.parse(
				JSON.stringify([
					...(this.$store.state.onHoldRules.ElecToleranceRules || []).map(
						(r) => ({
							...r,
							Elec: true,
							Gas: false,
						})
					),
					...(this.$store.state.onHoldRules.GasToleranceRules || []).map(
						(r) => ({
							...r,
							Elec: false,
							Gas: true,
						})
					),
				])
			);

			this.localToleranceRules.forEach((rule) => {
				if (rule.MonthRule) {
					if (!rule.MonthRule.MinAmount || rule.MonthRule.MinAmount < 1)
						rule.MonthRule.MinAmount = 1;
					if (!rule.MonthRule.MaxAmount || rule.MonthRule.MaxAmount < 1)
						rule.MonthRule.MaxAmount = 1;
				}
			});
			this.loading = false;
		} catch (err) {
			this.$notify.error('Error fetching On Hold Rules');
			this.loading = false;
			throw err;
		}
	},

	methods: {
		restrictInput(event) {
			if (isNaN(event.key)) {
				event.preventDefault();
			}
		},

		toggleEnabled(rule, type) {
			if (type === 'gas') {
				rule.GasEnabled = !rule.GasEnabled;
			} else if (type === 'elec') {
				rule.ElecEnabled = !rule.ElecEnabled;
			} else {
				rule.Enabled = !rule.Enabled;
			}
		},

		setRadio(rule, type) {
			if (type === 'MeterPoint') {
				if (!rule.Statement) return;
				rule.MeterPoint = true;
				rule.Statement = false;
			} else if (type === 'Statement') {
				if (!rule.MeterPoint) return;
				rule.Statement = true;
				rule.MeterPoint = false;
			}
		},

		async submit() {
			try {
				await this.$store.dispatch('submitOnHoldRules', this.dto);
				this.$snotify.success('Success! On Hold Rules Updated');
			} catch (err) {
				this.$snotify.error('Error updating On Hold Rules');
				throw err;
			}
		},

		cancelForm() {
			this.$router.push('/');
		},

		enforceMonthMin(rule, field) {
			if (
				rule[field] === '' ||
				rule[field] === null ||
				rule[field] === undefined
			) {
				rule[field] = 1;
			} else if (Number(rule[field]) < 1) {
				rule[field] = 1;
			}
		},
	},
};
</script>
